import { render, staticRenderFns } from "./AEstadoEstudiante.vue?vue&type=template&id=34eae972"
import script from "./AEstadoEstudiante.vue?vue&type=script&lang=js"
export * from "./AEstadoEstudiante.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports